/**
 * HUMANSTARSapp
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerActionType = {
    Calendar: 'calendar',
    Chat: 'chat',
    Knowledgebase: 'knowledgebase',
    News: 'news'
} as const;
export type CustomerActionType = typeof CustomerActionType[keyof typeof CustomerActionType];
